export function searchDomain(e) {
  const domain = e.target.elements.domain.value
  window.location = `https://order.cyon.ch/order/public/domains/#${domain}`
}
